(function () {
  'use strict';
  function init(root) {
    if (root.dataset.initialized === 'true') return;
    var form = document.getElementById(root.dataset.formId);
    var select = root.querySelector('[data-hol-cable-select]');
    var property = root.querySelector('[data-hol-cable-property]');
    var status = root.querySelector('[data-hol-cable-status]');
    if (!form || !select || !property) return;
    root.dataset.initialized = 'true';
    function update() {
      var option = select.selectedOptions[0];
      property.value = option.dataset.label;
      var price = Number(option.dataset.price || 0);
      var amount = new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' }).format(price / 100);
      status.textContent = price ? root.dataset.priceMessage.replace('[amount]', amount) : '';
      var accelerated = form.querySelector('.shopify-payment-button');
      if (accelerated) accelerated.hidden = price > 0;
    }
    select.addEventListener('change', update);
    update();
    form.addEventListener('submit', async function (event) {
      var addonId = Number(select.value);
      if (!addonId || event.defaultPrevented) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (root.dataset.busy === 'true' || !form.reportValidity()) return;
      var component = form.closest('product-form');
      var button = form.querySelector('[type="submit"]');
      if (button && button.classList.contains('loading')) return;
      var spinner = component && component.querySelector('.button-overlay-spinner');
      var data = new FormData(form);
      var id = Number(data.get('id'));
      var quantity = Math.max(1, Number(data.get('quantity') || 1));
      var properties = {};
      data.forEach(function (value, key) {
        var match = /^properties\[(.+)\]$/.exec(key);
        if (match && typeof value === 'string') properties[match[1]] = value;
      });
      var group = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
      properties._hol_cable_group = group;
      var parent = { id: id, quantity: quantity, properties: properties };
      if (data.get('selling_plan')) parent.selling_plan = data.get('selling_plan');
      var payload = { items: [parent, { id: addonId, quantity: quantity, parent_id: id, properties: { _hol_cable_group: group, _hol_parent_variant: String(id) } }], sections_url: window.location.pathname };
      var cart = document.querySelector('mini-cart');
      if (cart && cart.getSectionsToRender) payload.sections = cart.getSectionsToRender().map(function (section) { return section.section; });
      root.dataset.busy = 'true';
      if (component && component.handleErrorMessage) component.handleErrorMessage();
      if (button) { button.classList.add('loading'); button.setAttribute('aria-disabled', 'true'); }
      if (spinner) spinner.classList.remove('hidden');
      try {
        var response = await fetch((window.Shopify && window.Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) });
        var result = await response.json();
        if (!response.ok || result.status) {
          if (cart && cart.updateSectionContents) cart.updateSectionContents();
          throw new Error(result.description || result.message || root.dataset.errorMessage);
        }
        if (cart && cart.renderContents) {
          try { cart.renderContents(result); cart.open(button); }
          catch (renderError) { window.location.assign((window.Shopify && window.Shopify.routes.root || '/') + 'cart'); }
        }
        else window.location.assign((window.Shopify && window.Shopify.routes.root || '/') + 'cart');
        var items = result.items || [result];
        var eventContext = form.dataset.eventContext;
        document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { items: items, context: eventContext } }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') publish(PUB_SUB_EVENTS.cartItemAdd, { source: eventContext, items: items });
        if (window.themeSettings && window.themeSettings.redirectToCart) window.location.assign(window.routes.cart_url);
      } catch (error) {
        var message = error.message || root.dataset.errorMessage;
        if (component && component.handleErrorMessage) component.handleErrorMessage(message);
        else status.textContent = message;
      } finally {
        root.dataset.busy = 'false';
        if (button) { button.classList.remove('loading'); button.removeAttribute('aria-disabled'); }
        if (spinner) spinner.classList.add('hidden');
      }
    }, true);
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-hol-cable-options]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
